import React from 'react';
import ReactModal from 'react-modal';

import ModalInboxOperationContent from './ModalInboxOperationContent';

const ModalInboxOperation = ({
  isOpen,
  cashBoxName,
  type,
  onTransactionSubmit,
  closeModelCreateTransaction,
  disabledButton,
  transactionData,
  refundThings,
  recalculation,
  messageInfoElement
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overflow-modal"
      overlayClassName="modal-overlay">
      <ModalInboxOperationContent
        cashBoxName={cashBoxName}
        type={type}
        onTransactionSubmit={onTransactionSubmit}
        closeModelCreateTransaction={closeModelCreateTransaction}
        disabledButton={disabledButton}
        transactionData={transactionData}
        refundThings={refundThings}
        recalculation={recalculation}
        messageInfoElement={messageInfoElement}
      />
    </ReactModal>
  );
};

export default ModalInboxOperation;
